// src/components/Header.js

import { Link } from "react-router-dom";
import styles from "../styles/App.module.css";
import { DropdownButton, Dropdown } from "react-bootstrap";

function Header() {
  return (
    <header className={styles.siteHeader}>
      <h1 className={styles.siteTitle}>
        <Link to="/">L&nbsp;D&nbsp;Counselling</Link>
      </h1>

      {/* Desktop Navigation */}
      <nav className={styles.siteNavbar}>
        <Link to="/" className={styles.navLink}>
          Home
        </Link>
        <Link to="/about" className={styles.navLink}>
          About
        </Link>
        <Link to="/approach" className={styles.navLink}>
          Approach
        </Link>

        <Link to="/testimonials" className={styles.navLink}>
          Testimonials
        </Link>
        <Link to="/contact" className={styles.navLink}>
          Contact
        </Link>
      </nav>

      {/* Mobile Navigation */}
      <nav className={styles.mobileMenu}>
        <DropdownButton
          id="dropdown-basic-button"
          title="☰"
          className={styles.burgerButton}
        >
          <Dropdown.Item href="/">Home</Dropdown.Item>
          <Dropdown.Item href="/about">About</Dropdown.Item>
          <Dropdown.Item href="/approach">Approach</Dropdown.Item>
          <Dropdown.Item href="/testimonials">Testimonials</Dropdown.Item>
          <Dropdown.Item href="/contact">Contact</Dropdown.Item>
        </DropdownButton>
      </nav>
    </header>
  );
}

export default Header;
